import GridSearchTest from "../Components/RetrievalTest/GridSearchTest";

const GridSearchTestPage = () => {
  return <GridSearchTest />;
};

export default GridSearchTestPage;
